import React from 'react';
import SMConst from 'lib/SMConst';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMAcademyLinkResource from 'resources/SMAcademyLinkResource';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMOAcademyLinkBaloonView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      display: SMConst.AcademyLinkDisplay.Open,
      academyLinks: [],
    };
  }
  
  componentDidMount() {
    SMAcademyLinkResource.getAcademyLinks({display_place: this.props.displayPlace}, (academyLinks, error)=>{
      if (!error) {
        this.setState({academyLinks: academyLinks});
      }
    });
  }
  
  baloonDidClick() {
    if (this.state.display == SMConst.AcademyLinkDisplay.Open) {
      this.setState({display: SMConst.AcademyLinkDisplay.Close});
    } else {
      this.setState({display: SMConst.AcademyLinkDisplay.Open});
    }
  }
  
  render() {
    if (this.state.academyLinks.length == 0 || !this.props.isCurrent) return null;
    const academyTips = [];
    const academyBaloon = [];
    const academyBatch = [];
    const academyTipsBottom = this.state.display == SMConst.AcademyLinkDisplay.Open ? {bottom: '150px'} : {bottom: '90px'};
    const rows = this.state.academyLinks.map((academy) => {
      return(
        <li className="academy-tips__baloon-link"><a href={academy.link} className="link-hover-border" target="_blank">{academy.title}</a></li>
      );
    });
    
    if (this.state.display == SMConst.AcademyLinkDisplay.Open) {
      academyBaloon.push(
        <div className="academy-tips" key={this.state.display} style={{bottom: '150px'}}>
          <div className="baloon baloon-right academy-tips__baloon">
            <div className="baloon-inner academy-tips__baloon-inner">
              <h2 className="academy-tips__baloon-title">登録のヒント</h2>
              <p><a href="#" className="academy-tips__close" onClick={this.baloonDidClick.bind(this)}><i className="fa fa-times fa-lg"></i></a></p>
              <ul>
                {rows}
              </ul>
            </div>
          </div>
        </div>
      );
    } else {
      academyBatch.push(
        <div className="academy-tips__badge"></div>
      );
    }
    
    academyTips.push(
      <div className="academy-tips" style={academyTipsBottom} key={this.state.display}>
        <a href="#" onClick={this.baloonDidClick.bind(this)}><img src={SMRailsBridge.assetPath.logoMark} className="academy-tips__icon" /></a>
      </div>
    );
    
    return (
      <div>
        <CSSTransitionGroup transitionName={this.state.display == SMConst.AcademyLinkDisplay.Open ? "js-up-slide-animation" : "js-down-slide-animation"} transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {academyTips}
        </CSSTransitionGroup>
        <CSSTransitionGroup transitionName="js-batch-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {academyBatch}
        </CSSTransitionGroup>
        <CSSTransitionGroup transitionName="js-baloon-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300} transitionAppear={true}>
          {academyBaloon}
        </CSSTransitionGroup>
      </div>
    );
  }
}
export default SMOAcademyLinkBaloonView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/SMOAcademyLinkBaloonView.jsx